import {
    Cloud as IconCloudiness,
    Opacity as IconPrecipitation,
    Thermostat as IconTemperature,
    CompareArrows as IconWindDirection,
    Air as IconWindForce,
} from "@mui/icons-material";
import { Typography } from "@mui/material";
import { JSX } from "react";

import { ReviewVisitTableCell } from "../../../../../components/ReviewVisitTable";
import { FinalReportWeatherCardFragment } from "../fragment.generated";

type Props = {
    metric: string;
    condition: FinalReportWeatherCardFragment["conditions"][number];
};

export default function FinalReportWeatherCardTableRow({ metric, condition }: Props) {
    return (
        <>
            <ReviewVisitTableCell direction="row" gap={1} alignItems="center">
                {ICON_CONFIG[condition.name]}
                <Typography variant="body2">{metric}</Typography>
            </ReviewVisitTableCell>

            <ReviewVisitTableCell>
                <Typography variant="body2">{condition.startLabel ?? "—"}</Typography>
            </ReviewVisitTableCell>

            <ReviewVisitTableCell>
                <Typography variant="body2">{condition.endLabel ?? "—"}</Typography>
            </ReviewVisitTableCell>
        </>
    );
}

const ICON_CONFIG: Record<string, JSX.Element> = {
    temperature: <IconTemperature />,
    windForce: <IconWindForce />,
    precipitation: <IconPrecipitation />,
    windDirection: <IconWindDirection />,
    cloudiness: <IconCloudiness />,
};
